import React from 'react';
import ModerationRulebookSection from '../../../sections/AdminDashboard/Moderation/ModerationRulebook';

const AdminModerationRulebook = () => {
  return <ModerationRulebookSection />;
};

export default AdminModerationRulebook;

